import { render } from "./prjCard.vue?vue&type=template&id=16d5f410&scoped=true"
import script from "./prjCard.vue?vue&type=script&lang=js"
export * from "./prjCard.vue?vue&type=script&lang=js"

import "./prjCard.vue?vue&type=style&index=0&id=16d5f410&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16d5f410"]])

export default __exports__